import axios from 'axios';
import { API_URL } from '../config';

export const getMetaData = () => axios.get(`${API_URL}/Metadata`);
